import { render, staticRenderFns } from "./PlayVideoWrapper.vue?vue&type=template&id=bb397d52&"
import script from "./PlayVideoWrapper.vue?vue&type=script&lang=ts&"
export * from "./PlayVideoWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./PlayVideoWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsPlay: require('/tmp/build_dc55b0b5/src/components/icons/play.vue').default,ButtonCircle: require('/tmp/build_dc55b0b5/src/components/button/Circle.vue').default,Button: require('/tmp/build_dc55b0b5/src/components/button/Button.vue').default,ModalVideoPlayer: require('/tmp/build_dc55b0b5/src/components/modal/VideoPlayer.vue').default})
